import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import './geography.css';
import { useFilter } from '../../../contexts/filter-context';
import { Loading } from '../../widgets/loading/loading';
import '@arcgis/map-components/dist/components/arcgis-map';
import '@arcgis/map-components/dist/components/arcgis-zoom';
import '@arcgis/map-components/dist/components/arcgis-legend';
// import '@arcgis/map-components/dist/components/arcgis-basemap-layer-list';

const phaseToLayerIdMap = {
  '1961df15845-layer-9': 1, // Vulnerability
  '1961df189e5-layer-11': 2, // Exploitation
  '1961df1b3a5-layer-13': 3, // Prevention
  '1961df19a83-layer-12': 4, // Safety
  '1961df1c2e6-layer-14': 5, // Empowerment
  '1961df17c77-layer-10': 6, // Prosecution
  '1961df14b66-layer-8': 7, // Policy
};

export const GeographyPage = ({ activities, onOrganizationSelect }) => {
  const [isLoading, setIsLoading] = useState(false);
  const state = useFilter();

  const mapViewRef = useRef(null);

  const configureMap = () => {
    if (!!mapViewRef.current?.map) {
      const map = mapViewRef.current.map;

      // console.log('map = %o, mapView is = %o', map, mapViewRef.current);
      map.layers.forEach((l) => {
        // console.log('layer l.id = %o, l.title = %o, l = %o', l.id, l.title, l);
        l.visible = phaseToLayerIdMap[l.id] && (state.phaseIds.length === 0 || state.phaseIds.includes(phaseToLayerIdMap[l.id]));
      });
    }
  };

  const mapCB = useCallback((mapView) => {
    if (mapView === null) {
      // DOM node referenced by ref has been unmounted
    } else {
      mapViewRef.current = mapView;
      mapView.addEventListener('arcgisViewReadyChange', () => {
        configureMap();
      });
    }
  }, []);

  useEffect(() => {
    if (mapViewRef.current) {
      configureMap();
    }
  }, [state]);

  return (
    <div className="geography-page">
      {isLoading && (
        <div className="geography-loading-container">
          <Loading />
        </div>
      )}
      {!isLoading && (
        <div className="geography-map-container">
          <div className="geography-empty-message">No organizations found that meet the currently selected filters</div>
          <arcgis-map ref={mapCB} item-id="1fccf76daeb74de586a4c799ba1ff42a">
            {/* <arcgis-map item-id="66be81c22e224eb1a575f9fe7f135f54"> */}
            <arcgis-zoom position="top-left"></arcgis-zoom>
            {/* <arcgis-legend position="bottom-left"></arcgis-legend> */}
            {/* <arcgis-layer-list position="top-right"></arcgis-layer-list> */}
            {/* <arcgis-basemap-layer-list position="top-right"></arcgis-basemap-layer-list> */}
          </arcgis-map>
        </div>
      )}
    </div>
  );
};
